module.exports = __webpack_public_path__ + "img/dodolar.8f46d084.png";